<template>
	<div class="nav-class" :style="dataStyle">
		<div class="nav-cont">
			<div class="tit">{{dataTit}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataTit: {
				type: String,
				default: ''
			},
			dataStyle: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				model: ''
			}
		},
		mounted () {
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.nav-class{
		background-color: #f7f7f7;
		position: fixed;
		left: 0;
		right: 0;
		z-index: 13;
		.nav-cont{
			padding: 10px 10px 10px 10px;
			display: flex;
			color: #000000;
			justify-content: center;
			.tit{
				font-size: 17px;
			}
		}
		.active1{
			padding-top: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/public/navTit.vue